<template>
  <router-link :to="'/simcard_profile_group/' + item.id" class="link">
    <tr class="profile_group_item pointer">
      <td class="w50" data-label="ID">{{ item.id }}</td>
      <td class="text-left" :data-label="translate('simcard_profile_group.name')">{{ item.name }}</td>
      <td :data-label="translate('simcard_profile_group.group_type')">{{ item.group_type }}</td>
      <td class="text-left" :data-label="translate('client.one')">{{ client_name }}</td>
      <td class="w100" :data-label="translate('simcard_profile_group.members_count')">{{ item.members_count }}</td>
      <td class="text-left" :data-label="translate('simcard_profile_group.description')">{{ item.description }}</td>
      <td :data-label="translate('simcard_profile.ts_create')" v-html="get_date_any_lines(item.created_at, null, 2)" />
      <td :data-label="translate('simcard_profile.ts_update')" v-html="get_date_any_lines(item.updated_at, null, 2)" />
    </tr>
  </router-link>
</template>

<script>
export default {
  name: 'SimCardProfileGroupListItem',
  props: ['item'],
  computed: {
    client_name() {
      return this.$store.getters.getClientById(this.item.client_id)?.name
    }
  }
}
</script>

<style lang="scss" scoped>
.profile_group_item {
  font-size: 12px;
  td {
    vertical-align: middle;
  }
  &:hover {
    background-color: #eee;
  }
  .text-left {
    text-align: left;
  }
}
</style>
